import { calculateMinAda } from "@blaze-cardano/sdk";
import { useMutation } from "@tanstack/react-query";
import orderBy from "lodash/orderBy";
const lovelacePerByte = 4310;
export const useGetChosenUtxos = () => {
    const mutation = useMutation(async (data) => {
        try {
            // If the wallet gives us no UTXOs to work with, display the not-enough-ada warning
            if (data.length === 0) {
                return {
                    notEnoughAda: true,
                    data: [],
                };
            }
            const orderedUtxos = orderBy(data, [
                (utxo) => utxo.output().amount().multiasset()?.size || 0,
                (utxo) => utxo.output().amount().coin(),
            ], ["asc", "desc"]);
            const chosenUtxos = [];
            // Make sure we have at least 2 ada for the minUTXO requirement, plus the on-chain fee, plus .3 ada network fee
            let minADA = 2000000n + 500000n + 300000n;
            let total = 0n;
            for (const utxo of orderedUtxos) {
                chosenUtxos.push(utxo);
                total += utxo.output().amount().coin();
                // Each time we add some tokens, that increases the minADA of the change UTXO
                minADA += calculateMinAda(utxo.output(), lovelacePerByte);
                if (total >= minADA) {
                    break;
                }
            }
            return {
                notEnoughAda: total < minADA,
                data: chosenUtxos,
            };
        }
        catch (e) {
            return null;
        }
    });
    return mutation;
};
//# sourceMappingURL=useGetChosenUtxos.js.map